import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const GoogleCallback = ({ onLoginSuccess }) => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

    useEffect(() => {
        const handleCallback = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get('code');

                if (!code) {
                    setError('No authorization code found in the URL');
                    return;
                }

                console.log('Sending code to backend:', code); // 디버깅용 로그

                const response = await fetch(`${apiBaseUrl}/api/v1/auth/google-login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ code }),
                });

                const data = await response.json();

                if (!response.ok) {
                    console.error('Backend error:', data); // 디버깅용 로그
                    setError(data.detail || `Server error: ${response.status}`);
                    return;
                }

                if (!data.access_token) {
                    setError('JWT not received from server');
                    return;
                }

                onLoginSuccess(data.access_token);
                navigate('/map');
            } catch (error) {
                console.error('Error during login process:', error);
                setError(`An unexpected error occurred: ${error.message}`);
            } finally {
                setIsLoading(false);
            }
        };

        handleCallback();
    }, [navigate, onLoginSuccess, apiBaseUrl]);

    if (isLoading) {
        return <div>Processing login...</div>;
    }

    if (error) {
        return (
            <div>
                <p>Error: {error}</p>
                <button onClick={() => navigate('/login')}>Return to Login</button>
            </div>
        );
    }

    return null;
};

export default GoogleCallback;